import ProviderDashboard from "../../components/Provider/ProviderDashboard";
import Layout from "../../components/Layout";

function Provider() {
    return (
        <>
            <Layout>
                <div className="bg-indigo-50 xl:px-40 lg:px-40 md:px-10 sm:px-10 xs:px-8 ">
                    <div className="py-10 w-full">
                        <ProviderDashboard />
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Provider;